<app-spinner></app-spinner>
<app-block-module></app-block-module>
<div class="bc-content-body">
  <router-outlet></router-outlet>
</div>
